import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface SurveyGraphState {
  id?: string,
  nodes: Survey.Series.Node[],
  connections: Survey.Series.Connection[],
  outcomes: string[]
}

const initialState: SurveyGraphState = {
  id: undefined,
  nodes: [],
  connections: [],
  outcomes: []
}

export const surveyGraphSlice = createSlice({
  name: "survey_graph",
  initialState,
  reducers: {
    reset: (state, action: PayloadAction<SurveyGraphState>) => action.payload,
    addNode: (state, action: PayloadAction<Survey.Series.Node>) => {
      state.nodes.push(action.payload);
      return state;
    },
    addConnection: (state: SurveyGraphState, action: PayloadAction<Survey.Series.Connection>) => {
      state.connections.push(action.payload);
      return state;
    },
    removeConnection: (state: SurveyGraphState, action: PayloadAction<string>) => {
      state.connections = state.connections.filter((c) => c.id !== action.payload);
      return state;
    },
    updateConnection: (state: SurveyGraphState, action: PayloadAction<{id: string, connection: Survey.Series.Connection}>) => {
      const index = state.connections.findIndex((c) => c.id === action.payload.id);
      if (index === -1)
        return state;

      state.connections[index] = action.payload.connection;
      return state;
    },
    setPosition: (state: SurveyGraphState, action: PayloadAction<{id: string, position: {x: number, y: number}}>) => {
      const nodeIndex = state.nodes.findIndex((n) => n.id === action.payload.id);
      if (nodeIndex === undefined) return state;

      state.nodes[nodeIndex].position = action.payload.position;
      return state;
    }
  }
})

export const {
  reset: initializeGraph,
  addNode: addSeriesNode,
  updateConnection: updateSeriesConnection,
  setPosition: setNodePosition,
  addConnection: addSeriesConnection,
  removeConnection: removeSeriesConnection
} = surveyGraphSlice.actions;
export default surveyGraphSlice.reducer;
